import { colors } from '@fikasio/styles';
import React from 'react';
import { Link } from 'react-router-dom';
import TrashIcon from 'components/UI/TrashIcon';
import { useDeleteTemplateMutation } from 'services/templates/api';
import links, { linkKey } from 'utils/links';

const TemplateRow = ({
  template,
}) => {
  const [deleteTemplate] = useDeleteTemplateMutation();

  return (
    <tr>
      <td
        style={{ cursor: 'pointer' }}
      >
        <Link
          style={{ textDecoration: 'none' }}
          to={links.template(linkKey(template))}
        >
          <div
            style={{
              color: '#000',
              height: '100%',
              width: '100%',
            }}
          >
            { template.name }
          </div>
        </Link>
      </td>
      <td width={35}>
        <TrashIcon
          size="1x"
          onClick={() => deleteTemplate(template.id)}
          style={{
            color: colors.danger,
            cursor: 'pointer',
          }}
        />
      </td>
    </tr>
  );
}

export default TemplateRow;
